<template>
  <section class="container m-auto h-full container flex justify-center items-center sm:h-full md:h-screen lg:h-screen xl:h-screen">
    <div class="w-3/4 sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3" v-bind:class="[ error ? 'p-12 border-2 rounded-md border-red-800 bg-red-200' : '']">
      <p v-if="error" class="text-center text-2xl text-red-800 mb-6">{{error}}</p>
      <div class="max-w-full mb-6 text-2xl text-gray-800 leading-8">
        <span class="text-base text-blue-500 leading-7">{{question.prefix}}.</span> 
        {{question.text}}
      </div>
      <p v-if="question.secondaryText" class="text-gray-600">{{question.secondaryText}}</p>
      <div class="rounded-md">
        <textarea
          rows="3"
          class="p-2 mt-1 text-xl block w-full transition duration-150 ease-in-out leading-normal"
          placeholder="Answer goes here..."
          :maxlength="question.maxLength"
          v-model="localText"
          v-bind:class="[ question.maxLength ? '' : 'mb-6']">
        </textarea>
      </div>
      <p v-if="question.maxLength" class="my-4 text-sm text-gray-500 sm:my-4 md:my-2 lg:my-2 xl:my-2">
        {{ localText === undefined ? question.maxLength : question.maxLength - localText.length }} characters remaining
      </p>
      <div class="h-full w-auto flex justify-center">
        <div class="submit-wrapper" v-for="(action, index) in question.actions" :key="index">
          <div class="button-wrapper items-center">
            <button class="bg-blue-700 hover:bg-gray-200 text-white hover:text-green-600 border border-blue-700 hover:border-green-600 font-bold py-2 px-6 text-lg rounded-lg"
              @click="$emit('input', question, localText); $emit('action', [ {action: action, orderNum: question.orderNum} ])">
                {{action.label}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ['error', 'index', 'question'],
  data () {
    return {
      localText: this.value
    }
  }
}
</script>